module.exports = __webpack_public_path__ + "img/settings_1280.6ce0c3e1.png";